import { Calendar, Phone } from "lucide-react";

const CAL_LINK = "https://cal.com/tabletalktv";

const StickyMobileCTA = () => (
  <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white/95 backdrop-blur-lg border-t border-[var(--color-border)] px-4 py-3 flex gap-2">
    <a
      href={CAL_LINK}
      className="btn-primary flex-1 py-3 text-sm"
    >
      <Calendar className="w-4 h-4" />
      Book Call
    </a>
    <a
      href="tel:+15163433353"
      aria-label="Call TableTalk TV"
      className="btn-secondary flex-1 py-3 text-sm"
    >
      <Phone className="w-4 h-4" />
      Call Now
    </a>
  </div>
);

export default StickyMobileCTA;
